import React from 'react';
import classNames from 'clsx';

import { Input } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.css';
import utilityStyle from '../../../../../../css-variables/utilities.module.css';

/**
 * @param {object} props
 * @param {number} [props.cost]
 * @param {(value: number) => void} props.setCost
 * @param {boolean} [props.slimInput]
 * @returns {JSX.Element}
 */

export const CostInput = ({ cost = 0, setCost, slimInput = true }) => {
  const handleChange = (value) => {
    setCost(value === '' || value === null ? 0 : Number(value));
  };
  return (
    <div className={style['input-wrapper']}>
      <Text textType={TextType.Label} value={messages.addToLocationLocationCostLabel} />
      <div className={classNames(style.cost, { [style['slim-input']]: slimInput })}>
        <Input className={utilityStyle['input-border']} data-testid='cost-input' onChange={handleChange} type='number' value={cost} />
      </div>
    </div>
  );
};
